
  const gateReport = {
    path: "/gate-report",
    name: "gateReport",
    component: () => import(/* webpackChunkName: "gate_report" */ "@/components/gateReport/GateReportIndex.vue"),
    meta: { authorize: ['Administrator', 'Manager', 'Factory'], requiresAuth: true }
  };

export default gateReport;
